import { makeAutoObservable } from "mobx";

export class LogicBuilderStore {
  selectedLogic = "";

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedLogic = (value) => {
    this.selectedLogic = value;
  };
}
